import { Injectable } from '@angular/core';
import { SealMockApiService } from '@shipsfocus/seal';
import { vesselOwnerships as vesselOwnershipsData, vesselTypes as vesselTypesData } from 'app/mock-api/database/vessel/data';
import cloneDeep from 'lodash-es/cloneDeep';

@Injectable({
  providedIn: 'root'
})
export class VesselMockApi {
  private _vesselTypes: { id: number; index: number; name: string; slug: string }[] = vesselTypesData;
  private _vesselOwnerships: { id: string; index: number; name: string; slug: string }[] = vesselOwnershipsData;

  constructor(private _sealMockApiService: SealMockApiService) {
    this.registerHandlers();
  }

  registerHandlers(): void {
    this._sealMockApiService.onGet('api/database/vessel/types').reply(() => {
      const vesselTypes = cloneDeep(this._vesselTypes);

      return [200, vesselTypes];
    });

    this._sealMockApiService.onGet('api/database/vessel/ownerships').reply(() => {
      const vesselOwnerships = cloneDeep(this._vesselOwnerships);

      return [200, vesselOwnerships];
    });
  }
}
